import { useLocale, useTranslations } from 'next-intl'

import { TSearchFilter } from '@/entities/map'

import { Filter } from '../../model/filter'

type Field = keyof TSearchFilter

export const useFilterOptions = () => {
  const locale = useLocale()
  const t = useTranslations('map.filter')

  const isKorean = locale === 'ko'

  const FILTER_OPTIONS: {
    title: string
    type: Filter
    field: Field[]
    width: number
  }[] = [
    {
      title: t('room_count'),
      type: Filter.RoomCounts,
      field: ['roomCounts'],
      width: isKorean ? 79 : 84,
    },
    {
      title: t('price'),
      type: Filter.UsingFee,
      field: ['minUsingFee', 'maxUsingFee'],
      width: isKorean ? 65 : 73,
    },
    {
      title: t('building_type'),
      type: Filter.PropertyTypes,
      field: ['propertyTypes'],
      width: isKorean ? 90 : 122,
    },
    {
      title: t('area'),
      type: Filter.PyeongSizes,
      field: ['pyeongSizes'],
      width: isKorean ? 65 : 71,
    },
    {
      title: t('floor'),
      type: Filter.Floors,
      field: ['floors'],
      width: isKorean ? 65 : 73,
    },
    {
      title: t('option'),
      type: Filter.Options,
      field: ['popularOptions', 'basicOptions', 'additionalOptions'],
      width: isKorean ? 65 : 90,
    },
    {
      title: t('discount'),
      type: Filter.RoomDiscounts,
      field: ['roomDiscounts'],
      width: isKorean ? 65 : 96,
    },
  ]

  return { FILTER_OPTIONS }
}
